import gql from 'graphql-tag.macro';

export const query = gql`
  query getContacts {
    contacts {
      id
      name
      phoneNumber
    }
  }
`;

const reducer = payload => payload.contacts;

export const getContacts = {
  query,
  reducer
};
